// extracted by mini-css-extract-plugin
var _1 = "Variable-modulefield__HkMcJ Field-moduleField__kZH_K";
export { _1 as "field" }
